import React from 'react';
import Form from 'react-bootstrap/Form';
import styles from '../styles/about/CookieConsent.module.scss';

const CookieOptionItem = (props) => {
    const {title, description, selected, button, viewOption, changeSelection} = props;

    const handleView = () => {viewOption(title);}
    const handleSelection = () => {changeSelection(title);}

    const buttonHtml =  button != 'disabled' &&
        <div className={styles.consentButton}>
            <Form.Check 
                type="switch"
                id={title}
                label={button == 'on' ? 'Activ' : 'Inactiv'}
                onClick={handleSelection}
                defaultChecked={button == 'on' ? true : false}
            />
        </div>;


    return (
        <>
            <span 
                className={`${styles.categoryItem} ${selected ? styles.selected : ''}`}
                onClick={handleView}
            >
                {title}
            </span>
            {selected && 
            <div className={styles.categoryDescription}>
                <div className="py-2 d-flex justify-content-between align-items-start">
                    <span className="heading3">{title}</span>
                    {buttonHtml}
                </div>
                {description}
            </div>
            }   
        </>
    );
}

export default CookieOptionItem;